import { useAuth } from '@clerk/nextjs';
import { Master as MasterCustomer } from '@firmable/contracts/src/Supabase/Customer';
import { Master as MasterUser } from '@firmable/contracts/src/Supabase/User/User';
import { useQuery } from '@tanstack/react-query';
import { Query } from '@web/constants/query';
import axios from 'axios';

export interface MetadataApiResponse {
  metadata: MasterCustomer['metadata'];
  userMetadata: MasterUser['metadata'];
  success: true;
}

/**
 * React Query hook to fetch customer metadata
 * @returns ApiResponse | undefined
 */
export const useMetadata = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const { orgId } = useAuth();
  return useQuery({
    queryKey: [Query.CustomerKeys['metadata'], { orgId }],
    refetchOnWindowFocus: false,
    placeholderData: (previousData) => previousData,
    enabled: !!orgId && enabled,
    retry: false,
    staleTime: Infinity,
    queryFn: async () => {
      const response = await axios.get<MetadataApiResponse>(
        `${process.env.NEXT_PUBLIC_API_APP_ENDPOINT}/customer/metadata`,
      );
      return {
        metadata: response.data.metadata,
        userMetadata: response.data.userMetadata,
      };
    },
  });
};
